export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/equinix3-24cad9b72f06b2763c40c992859a1282.png";